<section class="t-widget h-full">
  <h2 class="t-widgetTitle">
    {{ "translate.supplies.createSupplyOrder" | translate }}
  </h2>
  <hr />

  <div class="l-margin-auto body-container">
    <loader *ngIf="!supplyTypes"></loader>

    <div
      *ngFor="let t of supplyTypes"
      class="supply-type"
      [class.selected]="t.selected"
      (click)="onItemSelect(t)"
    >
      <div class="icon-container">
        <img *ngIf="getIconPath(t)" [src]="getIconPath(t)" />
      </div>
      <p [class.selected]="t.selected">{{ t.text }}</p>
    </div>

    <div class="l-flex l-flex-row t-panel w-full submit-container">
      <div
        class="l-flex l-flex-column l-align-center l-cell-spread-x input-container"
      >
        <!--clinic-->
        <input-wrap
          *ngIf="displayClinicFields"
          [loading]="clinicList && clinicList.loading"
          cssClass="w-full"
        >
          <p-select
            class="t-input--colored"
            #hasSearchDropdown
            [options]="clinicList"
            optionLabel="label"
            [(ngModel)]="selectedClinic"
            [filterPlaceholder]="'translate.general.search' | translate"
            [placeholder]="'translate.general.clinic' | translate"
            [filter]="true"
            [resetFilterOnHide]="true"
            name="selectedClinic"
            (onChange)="onClinicChange()"
            [virtualScroll]="true"
            [virtualScrollItemSize]="30"
          >
          </p-select>
          <clear-multi
            *ngIf="selectedClinic"
            (click)="clearClinic()"
          ></clear-multi>
        </input-wrap>

        <!--notes-->
        <input-wrap cssClass="w-full">
          <textarea
            dir="auto"
            class="t-input t-input--colored"
            [class.strech]="!displayClinicFields"
            [(ngModel)]="notes"
            placeholder="{{ 'translate.general.notes' | translate }}"
          ></textarea>
        </input-wrap>
      </div>

      <div class="send-btn">
        <div class="l-align-y">
          <spinner *ngIf="sending"></spinner>
          <button
            class="l-cell-spread t-button-outline"
            (click)="createOrder()"
            [disabled]="sending || !allowSubmit()"
          >
            {{ "translate.general.send" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
